import { Api } from '@/api/api';
import { DataImportFileFilters } from '@/api/requests/import/data-import-file-filters';
import { DataImportFileUploadRequest } from '@/api/requests/import/data-import-file-upload-request';
import { DataImportFiles } from '@/api/responses/import/data-import-files';

export class ImportApi extends Api {
    public async getDataImportsAsync(filters: DataImportFileFilters): Promise<DataImportFiles> {
        return await this.getAsync<DataImportFiles>(`v1/import`, filters);
    }

    public async getDataImportValidationFileAsync(id: string): Promise<string> {
        return await this.getFileAsync(`v1/import/${id}/validation`);
    }

    public async uploadDataImportFileAsync(data: File, request: DataImportFileUploadRequest): Promise<string> {
        return await this.postFileAsync<string>(`v1/import?type=${request.type}&partnerPracticeId=${request.partnerPracticeId}`, data);
    }

    public constructor() {
        super();
    }
}
